import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, " Your Snap! Manage account has been upgraded to provide enhanced functionality and improved security. Please use your existing username and password to sign in and finish setup. ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Note to Parents/Guardians: Create an account if you don't already have one. ", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " Your FanX Portal account has been upgraded to provide enhanced functionality and improved security. Please use your existing username and password to sign in and finish setup. ", -1)
const _hoisted_6 = {
  key: 5,
  class: "mb-4 text-sm"
}
const _hoisted_7 = {
  key: 6,
  class: "mt-10 text-right md:text-center text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_InlineLink = _resolveComponent("InlineLink")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_Link = _resolveComponent("Link")!
  const _component_LoginForm = _resolveComponent("LoginForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showInviteParentAlert && !_ctx.publicFundraiserData)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 0,
          type: "info",
          class: "mb-6 md:absolute md:top-8 md:inset-x-8 z-10"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Sign up to help " + _toDisplayString(_ctx.inviteRequester?.firstName) + " " + _toDisplayString(_ctx.inviteRequester?.lastName) + " with their fundraiser. ", 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showInviteParentAlert && _ctx.publicFundraiserData)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 1,
          type: "info",
          class: "mb-6 md:absolute md:top-8 md:inset-x-8 z-10"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Sign up to help " + _toDisplayString(_ctx.inviteRequester?.firstName) + " " + _toDisplayString(_ctx.inviteRequester?.lastName) + " with their " + _toDisplayString(_ctx.publicFundraiserData.name) + " fundraiser. ", 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showInviteUserAlert)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 2,
          type: "info",
          class: "mb-6 md:absolute md:top-8 md:inset-x-8 z-10"
        }, {
          default: _withCtx(() => [
            _createTextVNode("You have an invite to Snap! Mobile. Please sign in to accept it. ")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showManageAlert)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 3,
          type: "info",
          class: "mb-6 md:absolute md:top-8 md:inset-x-8 z-10"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2,
            _hoisted_3,
            (_ctx.manageRegistrationLink)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                  _createVNode(_component_InlineLink, {
                    href: _ctx.manageRegistrationLink,
                    size: "sm"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Click Here to Browse Camps. ")
                    ]),
                    _: 1
                  }, 8, ["href"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showFanXAlert)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 4,
          type: "info",
          class: "mb-6 md:absolute md:top-8 md:inset-x-8 z-10"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_PageTitle, { class: "mb-4" }, {
      default: _withCtx(() => [
        _createTextVNode("Sign in With Your Snap! Mobile Account")
      ]),
      _: 1
    }),
    (_ctx.featureOn?.('USER-888-new-sign-up-view'))
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
          _createTextVNode(" New to Snap! Mobile? "),
          _createVNode(_component_Link, {
            to: { name: 'signup' },
            size: "sm"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Create Account")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_LoginForm, {
      prefill: _ctx.prefill,
      onResetPassword: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'reset-password' }))),
      "onForm:error": _ctx.onFormError
    }, null, 8, ["prefill", "onForm:error"]),
    (!_ctx.featureOn?.('USER-888-new-sign-up-view'))
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
          _createTextVNode(" Don't have a Snap! Mobile account? "),
          _createVNode(_component_Link, {
            to: { name: 'signup' },
            size: "sm"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Create an account.")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}